import React, { useMemo } from 'react';
import { DbThemeContext } from './ThemeContext';
import { defaultTheme } from './theme.default';
import type { DbThemeOverride, DbThemeConfig } from './theme.types';

interface DbThemeProviderProps {
    /** 自定义主题（会与默认主题深度合并） */
    theme?: DbThemeOverride;
    children: React.ReactNode;
}

/**
 * 全局主题提供者
 *
 * @example
 * // 在 App.tsx 中使用
 * <DbThemeProvider theme={{ colors: { primary: '#FF2442' } }}>
 *   <App />
 * </DbThemeProvider>
 *
 * @example
 * // 不传 theme 则使用默认主题
 * <DbThemeProvider>
 *   <App />
 * </DbThemeProvider>
 */
export const DbThemeProvider: React.FC<DbThemeProviderProps> = ({
    theme: themeOverride,
    children,
}) => {
    const mergedTheme = useMemo<DbThemeConfig>(() => {
        if (!themeOverride) return defaultTheme;

        return {
            colors: { ...defaultTheme.colors, ...themeOverride.colors },
            spacing: { ...defaultTheme.spacing, ...themeOverride.spacing },
            borderRadius: { ...defaultTheme.borderRadius, ...themeOverride.borderRadius },
            interaction: { ...defaultTheme.interaction, ...themeOverride.interaction },
            navBar: { ...defaultTheme.navBar, ...themeOverride.navBar },
        };
    }, [themeOverride]);

    return (
        <DbThemeContext.Provider value={mergedTheme}>
            {children}
        </DbThemeContext.Provider>
    );
};